module.exports = __webpack_public_path__ + "img/1439189208.c1780e25.jpg";